/**
 * Loox expanded summary: Shadow DOM zırhını delerek devasa yıldızı gizler.
 */
(function () {
  // Shadow DOM içine enjekte edilecek CSS kuralları
  var cssContent = `
    [data-testid="rating-summary-avg"] svg.loox-icon.star.loox-star,
    [data-testid="rating-summary-avg"] > svg.loox-icon,
    [data-testid="rating-summary-avg"] svg:first-of-type,
    .expanded-summary-avg svg.loox-icon,
    .expanded-summary-avg svg,
    .expanded-widget-header [data-testid="rating-summary-avg"] svg,
    .expanded-widget-header .summary-text svg {
      display: none !important;
      visibility: hidden !important;
      width: 0 !important;
      height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      pointer-events: none !important;
      opacity: 0 !important;
      position: absolute !important;
    }
  `;

  // Stili hedeflenen node'un içine ekleyen fonksiyon
  function injectStyleIntoNode(node, id) {
    // Eğer daha önce eklediysek tekrar ekleme
    if (!node || (node.getElementById && node.getElementById(id)) || node.querySelector('#' + id)) return;
    
    var style = document.createElement('style');
    style.id = id;
    style.innerHTML = cssContent;
    
    if (node.nodeName === 'HEAD') {
      node.appendChild(style);
    } else {
      // Shadow root ise en başa ekle
      node.prepend(style);
    }
  }

  // Tüm sayfayı tarayıp hem ana DOM'a hem de Shadow DOM'lara stili basar
  function scanAndInject() {
    // 1. Ana dokümana enjekte et
    injectStyleIntoNode(document.head, 'loox-custom-hide-star-main');

    // 2. Sayfadaki tüm Shadow DOM'ları bul (Loox widget'ları dahil)
    var allElements = document.querySelectorAll('*');
    for (var i = 0; i < allElements.length; i++) {
      if (allElements[i].shadowRoot) {
        injectStyleIntoNode(allElements[i].shadowRoot, 'loox-custom-hide-star-shadow-' + i);
      }
    }
  }

  // Sayfa yüklendiğinde çalıştır
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAndInject);
  } else {
    scanAndInject();
  }

  // Loox widget'ı sonradan yüklenirse diye MutationObserver ile pusuda bekle
  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      scanAndInject();
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();